export default __webpack_public_path__ + "static/media/background-register.a6d77d39.png";